// import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// export function noDuplicates(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     if (!control || !Array.isArray(control.value)) return null;

//     const values = control.value.map(v => (v ?? '').toString().trim());

//     const hasDuplicate = values.some(
//       (val, idx) => val !== '' && values.indexOf(val) !== idx
//     );

//     return hasDuplicate ? { duplicates: true } : null;
//   };
// }


import { AbstractControl, ValidationErrors, ValidatorFn, FormArray, FormControl } from '@angular/forms';

export function noDuplicates(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormArray)) return null;

    const formArray = control as FormArray;
    const values = formArray.controls.map(c => c.value?.toString().trim());

    // Find duplicates
    const duplicateIndexes: number[] = [];
    values.forEach((val, idx) => {
      if (val && values.indexOf(val) !== idx) {
        duplicateIndexes.push(idx);
      }
    });

    // get all duplicated emails
    const idx = duplicateIndexes?.[0];
    if (idx != null) {
      const email = values?.[idx];
      duplicateIndexes.push(values.indexOf(email));
    }

    // Clear old errors first
    formArray.controls.forEach(c => {
      const errors = c.errors;
      if (errors && errors['duplicate']) {
        delete errors['duplicate'];

        if (Object.keys(errors).length === 0) {
          c.setErrors(null);
        } else {
          c.setErrors(errors);
        }
      }
    });

    // Mark duplicate controls as invalid
    duplicateIndexes.forEach(index => {
      const control = formArray.at(index) as FormControl;
      control.setErrors({ ...(control.errors || {}), duplicate: true });
    });

    return duplicateIndexes.length > 0 ? { duplicates: true } : null;
  };
}